import { Trash } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";

import { useCampaignFlowContext } from "../../../../context/CampaignFlowContext";
import { useFlowTemplateContext } from "./FlowTemplateContext";

export default function RemoveButton() {
  const { canEditFlow } = useCampaignFlowContext();
  const { flowTemplate, isRemoveButtonHidden, handleRemove } =
    useFlowTemplateContext();

  const canShowRemoveButton = !(
    isRemoveButtonHidden || flowTemplate.type === "INMAIL_TEMPLATE"
  );

  if (!canShowRemoveButton) return null;

  return (
    <Button
      variant="outline-danger"
      className="ml-auto"
      leftIcon={<Trash />}
      onClick={handleRemove}
      disabled={!canEditFlow}
    >
      Remove
    </Button>
  );
}
